import {
  Device,
  Domain,
  Placement,
  ProductType,
  SessionId,
  USAStateAcronym,
  ZipCode,
} from '@hc-frontend/core-types';
import { z } from 'zod';

import { AdImpression } from './ad-impression';
import { FeaturedAd } from './featured-ad';
import { FeaturedAds } from './featured-ads';

export const TrackConversionOptions = z.object({
  featureAd: FeaturedAd.pick({ cpc: true, id: true }),
  featureAds: FeaturedAds.pick({ id: true }),
  placement: Placement,
  sessionId: SessionId,
});

export type TrackConversionOptions = z.infer<typeof TrackConversionOptions>;

export const TrackImpressionOptions = z.object({
  featureAds: FeaturedAds.pick({ result: true, id: true }),
  device: Device.optional(),
  placement: Placement,
  productType: ProductType,
  sessionId: SessionId,
  stateAcronym: USAStateAcronym,
  zipCode: ZipCode,
  domain: Domain,
});

export type TrackImpressionOptions = z.infer<typeof TrackImpressionOptions>;

export const TrackClickOptions = z.object({
  featureAd: FeaturedAd.pick({
    id: true,
    provider: true,
    link: true,
    dealType: true,
    cpc: true,
  }),
  clickCount: z.number(),
  impressionId: AdImpression,
  searchAdsId: z.string(),
  blockPosition: z.number(),
  pagePosition: z.number(),
  device: Device.optional(),
  placement: Placement,
  productType: ProductType,
  sessionId: SessionId,
  stateAcronym: USAStateAcronym,
  zipCode: ZipCode,
});

export type TrackClickOptions = z.infer<typeof TrackClickOptions>;
